const initialState = {
    episodeListModule: '',
    toEpisodeList: false,
  };
  
  export default initialState;